class SundayFAQ {
  constructor() {
    this.init();
  }

  init() {
    const faqToggles = document.querySelectorAll('[data-faq-toggle]');

    faqToggles.forEach(button => {
      button.addEventListener('click', () => this.toggleFAQ(button));

      button.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggleFAQ(button);
        }
      });
    });
  }

  toggleFAQ(button) {
    try {
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      const answerId = button.getAttribute('aria-controls');
      const answer = document.getElementById(answerId);

      if (!answer) {
        console.warn(`FAQ answer element not found: ${answerId}`);
        return;
      }

      button.setAttribute('aria-expanded', !isExpanded);
      answer.hidden = isExpanded;
    } catch (error) {
      console.error('Error toggling FAQ:', error);
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new SundayFAQ());
} else {
  new SundayFAQ();
}
